import React, { useState, useRef, useEffect } from "react";
import { MdNotifications } from "react-icons/md";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { IoSearch } from "react-icons/io5";

const Component2 = () => {
  const [isSearchActive, setIsSearchActive] = useState(false);
  const searchRef = useRef(null);

  // Close search when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setIsSearchActive(false);
      }
    };
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isSearchActive]);

  return (
    <div className="flex justify-center items-center mt-10 bg-white">
      {/* Hide logo & notification when search is active */}
      {!isSearchActive && (
        <>
          <img
            className=" mr-5 h-[30px]"
            src="/static/media/logo.0b902054ab86a6253951.png"
            alt="logo"
          />
          <div className="relative ml-12  mr-5 flex bg-gray-200 items-center justify-center w-10 h-10 rounded-xl cursor-pointer">
            <MdNotifications className="w-6 h-6 text-black" />
            <div className="absolute top-1 right-1 bg-orange-500 text-white text-xs font-bold w-4 h-4 flex items-center justify-center rounded-full">
              2
            </div>
          </div>
        </>
      )}

      <div className="flex items-center gap-2" ref={searchRef}>
        <div
          className={`flex items-center ${
            isSearchActive ? "bg-white px-4" : "bg-gray-200 px-2"
          } border border-gray-300 rounded-xl h-10`}
        >
          {isSearchActive && (
            <input
              type="text"
              placeholder="Search Here......"
              className="outline-none text-gray-500  md:w-[18vw] w-[40vw] placeholder-gray-400"
            />
          )}
          <IoSearch
            onClick={() => setIsSearchActive(true)}
            className="w-6 h-6 text-gray-500 cursor-pointer"
          />
        </div>
        {isSearchActive && (
          <button
            onClick={() => setIsSearchActive(false)}
            className="flex items-center w-10 h-10 bg-[#EAEAEA] rounded-lg justify-center text-gray-500"
          >
            <AiOutlineCloseCircle className="text-2xl text-primary" />
          </button>
        )}
      </div>
    </div>
  );
};

export default Component2;
